import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { pipe } from "fp-ts/lib/function";
import { option } from "fp-ts";
import { useStore } from "../../../store/hooks/use-store";
import {
  ProductDetailPageDataShared,
  type EnrichedSwarovskiProductFrontendBase,
  type EnrichedSwarovskiSingleProductFrontend,
} from "@swo/storefront";
import { createJpgLink } from "../../../components/_shared-components/image-related/createJpgAndWebpLinks";
import { getSwarovskiOptikHeadTitle } from "../../_layout-helpers/head-title";
import {
  PDPSwarovskiProductFrontend,
  PDPSwarovskiProductVariantFrontend,
} from "../PDP_SingleImageCarousel/state/types";

export const ProductDetailPageMetadata: ReactTFC<{
  selectedProduct: EnrichedSwarovskiProductFrontendBase;
  selectedVariant: PDPSwarovskiProductVariantFrontend | undefined;
  path: string;
  seoMetadata: ProductDetailPageDataShared["seoMetadata"];
}> = props => {
  const { locationOrigin } = useStore().state;

  const ogImage = pipe(
    props.selectedVariant?.images.thumbnail,
    option.fromNullable,
    option.alt(() => option.fromNullable(props.selectedProduct.images.thumbnail)),
    option.map(t => createJpgLink(t.url, 1200)),
    option.toUndefined,
  );

  return (
    <ProductVariantDetailPageMetadata
      title={props.selectedVariant?.name || props.selectedProduct.name}
      path={props.path}
      locationOrigin={locationOrigin}
      productCanonicalPath={props.seoMetadata.productCanonicalPath}
      ogImage={ogImage}
    />
  );
};

const ProductVariantDetailPageMetadata: ReactTFC<{
  title: string;
  path: string;
  locationOrigin: URL;
  productCanonicalPath: string;
  ogImage: string | undefined;
}> = props => {
  const canonical = new URL(props.productCanonicalPath, props.locationOrigin);

  return (
    <>
      <title>{getSwarovskiOptikHeadTitle(props.title)}</title>
      <link rel="canonical" href={canonical.toString()} /> {/* Canonical to main product */}
      {props.ogImage && <meta property="og:image" content={props.ogImage} />}
    </>
  );
};
